<div class="ref-search-box">
  <div class="control">
    <div class="ref-search-input-field">
      <div
        class="control has-icons-left"
        [class.has-icons-right]="terms.length > 0"
      >
        <input
          type="text"
          class="input"
          (keyup)="onSearchInputKeyup($event)"
          [placeholder]="label"
          (focus)="showList = true; focusedItemIndex = 0"
          [disabled]="readonly"
          autocomplete="off"
          #searchInput
        />
        <span class="icon is-left">
          <i class="icon {{ icon }}"></i>
        </span>
        <span
          class="icon is-right clear-icon"
          *ngIf="terms.length > 0"
          (click)="clearSearch()"
        >
          <i class="icon icon-x-circle"></i>
        </span>
      </div>

      <ul class="box list" *ngIf="showList && terms.length > 0">
        <li *ngIf="searching" class="search-loading">
          <span class="loader"></span>
        </li>
        <li
          *ngFor="let searchResult of suggestedSearchResults; let i = index"
          [ngClass]="{
            pointer: !isSelected(searchResult),
            'is-active is-disabled': isSelected(searchResult),
            'is-focused': focusedItemIndex === i && !isSelected(searchResult)
          }"
          (click)="!isSelected(searchResult) && toggleItem(searchResult)"
        >
          <i
            class="icon is-size-5 {{
              getResourceIcon(searchResult.resourceName)
            }}"
          ></i>
          <span>{{ searchResult.label }}</span>
        </li>
        <li
          *ngIf="searchComplete"
          class="pointer suggest-item"
          (click)="openSuggestPage()"
        >
          <i class="icon is-size-5 icon-plus"></i>
          <span>Suggest a new {{ resourceType }}</span>
        </li>
      </ul>
    </div>

    <div
      *ngIf="selectedSearchResults.length"
      class="selected-items mt-2 is-flex is-flex-wrap-wrap is-align-items-center"
    >
      <div
        *ngFor="let item of selectedSearchResults"
        class="tags has-addons mb-1 mr-1"
      >
        <a
          *ngIf="getCatalogueUrl(item)"
          class="tag is-link"
          [href]="getCatalogueUrl(item)"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="icon pr-5 pl-3 {{ getResourceIcon(item.resourceName) }}"></i
          >{{ item.label }}
        </a>
        <span *ngIf="!getCatalogueUrl(item)" class="tag is-link">
          <i class="icon pr-5 pl-3 {{ getResourceIcon(item.resourceName) }}"></i
          >{{ item.label }}
        </span>
        <a
          class="tag is-delete has-background-link-light"
          (click)="removeItem(item)"
          *ngIf="!readonly"
        ></a>
      </div>
    </div>
  </div>
</div>
